import { TRESPONSE_FACTORY_HOLIDAYS, TRESPONSE_FACTORY_SHIFT } from '@monorepo/types';

export type TShiftCategoryTab = 'WORKING_HOURS' | 'UPDATE_WORKFORCE' | 'ADD_DEFAULT_COUNT';
export type TAddDefaultCountSubTabs = 'DEFAULT_MANPOWER' | 'DEFAULT_WORKING_HOURS';
export type TAddEditRowType = 'ADD' | 'EDIT';

export type TLLShiftConf = {
  isLLConfig: boolean;
  llShiftConfig: TShiftCategoryTab;
  lineId: string;
  stripId?: string;
  factoryId: string;
};

export type TFactoryShiftState = {
  factoryShiftInfo: TRESPONSE_FACTORY_SHIFT | null;
  factoryHolidayInfo: TRESPONSE_FACTORY_HOLIDAYS | null;
  shiftCategoryTab: TShiftCategoryTab;
};

export const TFactoryShiftInfoActionType = {
  ClearFactoryShiftInfo: 'CLEAR_FACTORY_SHIFT_INFO' as const,
  SetShiftCategoryTab: 'SET_SHIFT_CATEGORY_TAB' as const,
  GetFactoryShiftInfo: 'GET_FACTORY_SHIFT_INFO' as const,
  GetFactoryShiftInfoSuccess: 'GET_FACTORY_SHIFT_INFO_SUCCESS' as const,
  GetFactoryShiftInfoFailure: 'GET_FACTORY_SHIFT_INFO_FAILURE' as const,
  AddEditOperatorCount: 'ADD_EDIT_FACTORY_OPERATOR_COUNT' as const,
  AddEditOperatorCountSuccess: 'ADD_EDIT_FACTORY_OPERATOR_COUNT_SUCCESS' as const,
  AddEditOperatorCountFailure: 'ADD_EDIT_FACTORY_OPERATOR_COUNT_FAILURE' as const,
  AddEditWorkingHours: 'ADD_EDIT_FACTORY_WORKING_HOURS' as const,
  AddEditWorkingHoursSuccess: 'ADD_EDIT_FACTORY_WORKING_HOURS_SUCCESS' as const,
  AddEditWorkingHoursFailure: 'ADD_EDIT_FACTORY_WORKING_HOURS_FAILURE' as const,
  ResetOperatorCount: 'RESET_FACTORY_OPERATOR_COUNT' as const,
  ResetOperatorCountSuccess: 'RESET_FACTORY_OPERATOR_COUNT_SUCCESS' as const,
  ResetOperatorCountFailure: 'RESET_FACTORY_OPERATOR_COUNT_FAILURE' as const,
  ResetWorkingHours: 'RESET_FACTORY_WORKING_HOURS' as const,
  ResetWorkingHoursSuccess: 'RESET_FACTORY_WORKING_HOURS_SUCCESS' as const,
  ResetWorkingHoursFailure: 'RESET_FACTORY_WORKING_HOURS_FAILURE' as const,
  GetFactoryHolidaysInfo: 'GET_FACTORY_HOLIDAY_INFO' as const,
  GetFactoryHolidaysInfoSuccess: 'GET_FACTORY_HOLIDAY_INFO_SUCCESS' as const,
  GetFactoryHolidaysInfoFailure: 'GET_FACTORY_HOLIDAY_INFO_FAILURE' as const,
  AddEditFactoryHoliday: 'ADD_EDIT_FACTORY_HOLIDAY' as const,
  AddEditFactoryHolidaySuccess: 'ADD_EDIT_FACTORY_HOLIDAY_SUCCESS' as const,
  AddEditFactoryHolidayFailure: 'ADD_EDIT_FACTORY_HOLIDAY_FAILURE' as const,
  DeleteFactoryHoliday: 'DELETE_FACTORY_HOLIDAY' as const,
  DeleteFactoryHolidaySuccess: 'DELETE_FACTORY_HOLIDAY_SUCCESS' as const,
  DeleteFactoryHolidayFailure: 'DELETE_FACTORY_HOLIDAY_FAILURE' as const,
  UpdateDefaultWorkforceCountRequest: 'UPDATE_DEFAULT_WORKFORCE_COUNT' as const,
  UpdateDefaultWorkforceCountRequestSuccess: 'UPDATE_DEFAULT_WORKFORCE_COUNT_SUCCESS' as const,
  UpdateDefaultWorkforceCountRequestFailure: 'UPDATE_DEFAULT_WORKFORCE_COUNT_FAILURE' as const,
  UpdateDefaultWorkingHoursRequest: 'UPDATE_DEFAULT_WORKING_HOURS' as const,
  UpdateDefaultWorkingHoursRequestSuccess: 'UPDATE_DEFAULT_WORKING_HOURS_SUCCESS' as const,
  UpdateDefaultWorkingHoursRequestFailure: 'UPDATE_DEFAULT_WORKING_HOURS_FAILURE' as const,
  AddEditWorkForceCount: 'ADD_EDIT_WORKFORCE_COUNT' as const,
  AddEditWorkForceCountSuccess: 'ADD_EDIT_WORKFORCE_COUNT_SUCCESS' as const,
  AddEditWorkForceCountFailure: 'ADD_EDIT_WORKFORCE_COUNT_FAILURE' as const,
  WorkForceResetToDefault: 'WORKFORCE_RESET_TO_DEFAULT' as const,
  WorkForceResetToDefaultSuccess: 'WORKFORCE_RESET_TO_DEFAULT_SUCCESS' as const,
  WorkForceResetToDefaultFailure: 'WORKFORCE_RESET_TO_DEFAULT_FAILURE' as const,
};
